module.exports = __webpack_public_path__ + "8ecede6925ccf2276ffe3a0a45a10abf.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-en.html
// module id = 932
// module chunks = 0